module.exports = __webpack_public_path__ + "img/zacSm.1f2a4c6e.png";